import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { appModernizationDetails } from '../../config';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { maintenanceV4APIs } from '../configV4';
import { configurableAttributesAPIs } from '../configV4';
import { GlobalCacheService } from './global-cache.service';
import { SharedAuthService } from '../../shared/shared.auth.service';


@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {
 

  public enabledInitiativeList = new BehaviorSubject <any>([]);
  public isEnabledInitiativesListSet: boolean = false;
  public addCapability = new Subject();
  public fundingSegment= new Subject();
  private apiUrl: string;
  private largeApiUrl: string;
  private config: any;
  private configV4: any;
  private configAttribute: any;
  private userDtls: any;
  leaderList$ = new BehaviorSubject<any>({});
  // cachedData: Map<string, any> = new Map<string, any>();  

  constructor(private http: HttpClient, private sharedAuthService: SharedAuthService,private cacheService: GlobalCacheService) {
    this.config = appModernizationDetails;
    
    this.apiUrl = environment.apiUrl;
    this.largeApiUrl = environment.LargeapiUrl;
    this.configV4 = maintenanceV4APIs;
    this.configAttribute = configurableAttributesAPIs;
    const currentUser = sessionStorage.getItem('currentUser') || '';
    this.userDtls = {
      cn: this.sharedAuthService.getMsid(),
      mail: sessionStorage.getItem('loggedInUserEmail') || '',
      givenName: currentUser ? currentUser.trim().split(',')[1].trim() : '',
      sn: currentUser ? currentUser.trim().split(',')[0].trim() : '',
    }
  }

  setAddCapability(value) {
    this.addCapability.next(value);
  }
  getFundingListSubjectValues() {
    return this.fundingSegment;
  }

  setFundingSubjectValues(data) {
    this.fundingSegment.next(data);
  }

  public getDecomLobAccess(msid): Observable<any> {
    const url = this.apiUrl + this.configV4.getDecomLobAccess;
    const payload = {
     
    }
    return this.http
      .post<any>(url, payload, { params: { msid } })
      .pipe(
        map(data => {
          return data;
        })
      );
  }

    public getLeadersOwnerList(searchLeader): Observable<any> {
      const url = this.apiUrl + this.configV4.getLeadersOwnerList + `?search=${searchLeader}`;
      return this.http.get<any>(url);
    }

  public getDecomLobAccessDetails():Observable<any>{
    const url = this.apiUrl + this.configV4.getDecomLobDetails;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      })
    ); 
  }


  public getMismatchHeirarchyData():Observable<any>{
    const url = this.apiUrl + this.configV4.getMismatchHeirarchyData;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      })
    ); 
  }

  public getMyPropRequestData():Observable<any>{
    const url = this.apiUrl + this.configV4.getMyPropRequestData;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      })
    ); 
  }

  public getMyPropApprovalData():Observable<any>{
    const url = this.apiUrl + this.configV4.getMyPropApprovalData;
    return this.http.get(url).pipe(
      map(data => {
        console.log(data,'data from getMyPropApprovalData');
        return data;
      })
    ); 
  }
  

  public getCdProposalDetails(reqId):Observable<any>{
    const url = this.apiUrl + this.configV4.getCdProposalDetails + `${reqId}`;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      })
    ); 
  }



  public cancelPropReq(payload):Observable<any>{
    const url = this.apiUrl + this.configV4.cancelPropReq;
    return this.http.put(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  public putLeaderOT(payload):Observable<any>{
    const url = this.apiUrl + this.configV4.putLeaderOT;
    return this.http.post(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  public GetLobArchitectMappingList(body): Observable<any> {
    const url = this.apiUrl + this.config.routerpath.GetLoBArchitectMapping;
    return this.http.get(url, body).pipe(
      map(data => {
        return data;
      })
    );
  }

  public SaveLobMapping(payload): Observable<any> {
    const url = this.apiUrl + this.config.routerpath.SaveLobMapping;
    return this.http.post(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  public UpdateLobMapping(payload): Observable<any> {
    const url = this.apiUrl + this.config.routerpath.UpdateLobMapping;
    return this.http.post(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  public addNewUcmg(body): Observable<any> {
    const url = this.apiUrl + this.config.routerpath.addUcmg;
    return this.http.put(url, body).pipe(
      map(data => {
        return data;
      })
    );
  }
  /**
 * Delete Mappings
 */
  public DeleteMappings(body): Observable<any> {
    const url = this.apiUrl + this.config.routerpath.DeleteLobMapping;
    const options: any = {};
    options['body'] = body;
    return this.http.delete(url, options).pipe(
      map(data => {
        return data;
      })
    );
  }

  public CreateLoB(payload): Observable<any> {
    const url = this.apiUrl + this.config.routerpath.Create_LoB;
    return this.http.post(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  public CreateSubLoB(payload): Observable<any> {
    const url = this.apiUrl + this.config.routerpath.Create_Sub_LoB;
    return this.http.post(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }
  
  public getOrganizationList(): Observable<any> {
    const url = this.apiUrl + this.config.routerpath.getOrgList;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  public addNewOrganization(body): Observable<any> {
    const url = this.apiUrl + this.config.routerpath.getOrgList;
    return this.http.put(url, body).pipe(
      map(data => {
        return data;
      })
    );
  }

  public editExistingOrganization(id, body): Observable<any> {
    const url = this.apiUrl + this.config.routerpath.getOrgList+`/${id}`;
    return this.http.put(url, body).pipe(
      map(data => {
        return data;
      })
    );
  }

  public deleteOrganization(body, id): Observable<any> {
  const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body
    }
    const url: string = this.apiUrl + this.config.routerpath.getOrgList + `/${id}`;
    return this.http.delete<any>(url, options);
  }

  public deleteSubLOB(body): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body
    }
    const url: string = this.apiUrl + this.configV4.deleteSubLob;
    return this.http.put<any>(url, options);
  }

  public addLOB(body): Observable<any> {
    const url: string = this.apiUrl + this.configV4.addLob;
    return this.http.put<any>(url, body);
  }

  public getLobDecomMapping(LOB_ID): Observable<any> {
    const url = this.apiUrl + this.configV4.lobLeaderDecom;
    return this.http.get(url, { params : { LOB_ID } });
  }

  public saveLobDecomMapping(body): Observable<any> {
    const url = this.apiUrl + this.configV4.saveLobLeaderDecom;
    return this.http.put(url, body);
  }

  public getDecomLobMasterMapping() : Observable<any> {
    const url = this.apiUrl + this.configV4.getDecomLobMasterMapping;
    return this.http.get(url);
  }

  public updateDecomLob(SubLobID, body) : Observable<any> {
    const url = this.apiUrl + this.configV4.updateDecomLob;
    return this.http.put(url, body , { params : { SubLobID } });
  }
  
  public editSubLOB(body): Observable<any> {
    const url: string = this.apiUrl + this.configV4.updateLob + '?type=sublob';
    return this.http.put<any>(url, body);
  }
  
  public editLLOB(body): Observable<any> {
    const url: string = this.apiUrl + this.configV4.updateLob + '?type=lob';
    return this.http.put<any>(url, body);
  }
  
  public checkLOB(body): Observable<any> {
    const url: string = this.apiUrl + this.configV4.checkLob;
    return this.http.post<any>(url, body);
  }

  public lobBulkUpload(body): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': ''
    });
    const options = {
      headers: headers
    }
    
  const url: string = this.apiUrl + this.configV4.bulklob;
  return this.http.put<any>(url, body, options).pipe(
    map(data => { return data; }));
  }

  public getCapitalDemandList(): Observable<any> {
    const url = this.apiUrl + this.configV4.fetCapitalDemandList;
    return this.http.get(url).pipe(
      map(data => {
        this.setFundingSubjectValues(data);
        return data;
      })
    );
  }

  public insertSegment(body): Observable<any> {
    const url = this.apiUrl + this.configV4.fetCapitalDemandList;
    return this.http.put(url, body);
  }

  public DeleteSegment(body): Observable<any> {
    const url = this.apiUrl + this.configV4.fetCapitalDemandList + '/' + body;
    return this.http.delete(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  public editSegmentById(body, segmentId): Observable<any> {
    const url = this.apiUrl + this.configV4.fetCapitalDemandList + '/' + segmentId;
    return this.http.put(url, body);
  }

  public getSegmenById(segmentId) :Observable<any>{
    const url = this.apiUrl + this.configV4.fetCapitalDemandList + '/' + segmentId;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  public postCapitalDemandUCMGLeader(body): Observable<any> {
    const url = this.apiUrl + this.configV4.functionAddCapitalDemandUCMGLeader;
    return this.http.put(url, body)
  }

  public postHierarchyMismatchLeader(body): Observable<any> {
    const url = this.apiUrl + this.configV4.editMismatchHierarchyLeader;
    return this.http.put(url, body)
  }
  
  public getUcmgHierarchyList(): Observable<any> {
    const url = this.apiUrl + this.configV4.getUcmgLeadersViewList;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      })
    );
  }


  
  public getHierarchyList(): Observable<any> {
    const url = this.apiUrl + this.configV4.getLeaderlist;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  public listCapitalDemandUCMGList(body, tree_level): Observable<any> {
    const url = this.apiUrl + this.configV4.functionCapitalDemandUCMGLeader + "?tree_level=" + tree_level;
    return this.http.post(url, body)
  }

  public putCapitalDemandUCMGLeader(body:any): Observable<any> {
    const url = this.apiUrl + this.configV4.functionCapitalDemandUCMGLeader;
    return this.http.put(url, body);
  }

  public deleteCapitalDemandUCMGLeader(body): Observable<any> {
    const url = this.apiUrl + this.configV4.functionCapitalDemandUCMGLeader;
    const options: any = {};
    options['body'] = body;
    return this.http.delete(url, options);
  }

  public getCapitalDemandInvestmentList(): Observable<any> {
    const url = this.apiUrl + this.configV4.fetchCapitalDemandInvestmentList;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  public getUCMGDetailsList(id: any): Observable<any> {
    const url = this.apiUrl + this.configV4.fetchUCMGDetailsListByID + id.toString();
    return this.http.get(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  public deleteCapitalDemand(body): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body
    }
    const url: string = this.apiUrl + this.config.routerpath.deleteDemand;
    return this.http.delete<any>(url,options);
  }

  public deleteUcmgLeader(params): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params
    }
    const url: string = this.apiUrl + this.config.routerpath.capitalDemandLeader;
    return this.http.delete<any>(url, options);
  }
  public editExistingLeader(body): Observable<any> {
    const url = this.apiUrl + this.config.routerpath.capitalDemandLeader;
    return this.http.put(url, body).pipe(
      map(data => {
        return data;
      })
    );
  }

  public addNewLeader(body): Observable<any> {
    const url = this.apiUrl + this.config.routerpath.addCapitalDemandLeader;
    return this.http.put(url, body).pipe(
      map(data => {
        return data;
      })
    );
  }
  
  public editUcmg(body,id): Observable<any> {
    const url = this.apiUrl + this.config.routerpath.addUcmg+`/${id}`;
    return this.http.put(url, body).pipe(
      map(data => {
        return data;
      })
    );
  }

  getLeaderListSubjectValues() {
    return this.leaderList$;
  }

  public getEnterpriseInitiatives(): Observable<any> {
    const url = this.apiUrl + this.config.routerpath.initiativeListUrl;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      })
    );
  }
  public setEnabledInitiativesData() {
    this.getEnterpriseInitiatives().subscribe((data: any) => {
      if (data && data.length > 0) {
        this.isEnabledInitiativesListSet = true;
        const enabledInitiativeList: Array<any> = data.filter((val) => {
          val.name = val.Initiative_Name;
          if (val.Enabled == 'Yes')
            return val;
        });
        if (enabledInitiativeList && enabledInitiativeList.length > 0) {
          this.enabledInitiativeList.next(enabledInitiativeList);
        }
      }
    }, error => {
      console.error('error', error);
    });
  }
  public getEnabledInitiativesRoleList(payload): Observable<any> {
    const url = this.apiUrl + this.config.routerpath.initiativeRoleListUrl+'/'+payload.initiativeID;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      })
    );
  }
  public updateEIRole(payload): Observable<any> {
    const url = this.apiUrl + this.config.routerpath.addEIRoleUrl;
   return this.http.put(url,payload)
   .pipe(
     map(data => {
       return data;
     })
   );
  }
 
  public getEIRoles(payload): Observable<any> {
    const url = this.apiUrl + this.config.routerpath.eiRoleListUrl+'/'+payload.initiativeID;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      })
    );
  }
  getFCServiceDtl(reqparams) {
    const url = this.apiUrl + this.configV4.fcServiceListUrl;
    return this.http.get(url,{params:reqparams}).pipe(
      map(data => {
        return data;
      })
    );
  }


  updateFCDetails(reqPayload) {
    const url = this.apiUrl + this.configV4.updateFCurl;
    return this.http.put(url,reqPayload)
    .pipe(
      map(data => {
        return data;
      })
    );
  }
 

  
  public getLOBList(): Observable<any> {
    const url = this.apiUrl + this.config.routerpath.getLobListUrl;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  
  setLeaderListSubjectValues(data) {
    this.leaderList$.next(data);
  }

  public getLeaderList(payload){
     const url = this.apiUrl + this.config.routerpath.capitalDemandLeader;
    return this.http.post(url,payload)
    .pipe(
      map(data => {
        this.setLeaderListSubjectValues(data);
        return data;
      })
    );
  }

 
  public getCIOMapping(body): Observable<any>{
    const url = this.apiUrl + this.configV4.fetchCIOMappingList;
    return this.http.post(url,body).pipe(
      map(data => {
        return data;
      })
    );
  }
  public addRemoveUsers(body): Observable<any>{
    const url = this.apiUrl + this.configV4.addRemoveUsers;
    return this.http.put(url,body).pipe(
      map(data => {
        return data;
      })
    );
  }
  public getForecastFilters() {
    const url = this.apiUrl + this.configV4.getForecastFilters;
    if (this.cacheService.has(url)) {
      return of(this.cacheService.get(url)); // Return cached data if available
    } else {
      return this.http.get(url).pipe(
        map(data => {
          this.cacheService.set(url, data); // Cache the data
          return data;
        })
      );
    }
  }
  public getForecastDetails(body) {
    const url = this.apiUrl + this.configV4.getForecastDetails;
    return this.http.post(url,body).pipe(
      map((data:Array<any>) => {
        if(data ){
          data.map((val,index)=>{
            val = this.getAggregatedDataForForecast(val);
          })
        }
        return data;
      })
    );
  }

  getAggregatedDataForForecast(val){
    val['Prev_FY_Total'] = 0;
    val['Current_Projections_Total']=0;
    val['Curr_Year_FC_Prev_Charges_Total']=0;
    val['Curr_Year_FC_Curr_Charges_Total']=0;
    val['Future_Year_FC_Prev_Charges_Total']=0;
    val['Future_Year_FC_Curr_Charges_Total']=0;
    
    val.services.forEach((el)=>{
      if(el.charges && el.charges.Prev_Year_FY_Charges != null){
        val['Prev_FY_Total'] += el.charges.Prev_Year_FY_Charges;
      }
      if(el.charges && el.charges.Infra_projected_Charges != null){
        val['Current_Projections_Total'] += el.charges.Infra_projected_Charges;
      }
      if(el.charges && el.charges.Curr_Year_FC_Prev_Charges != null){
        val['Curr_Year_FC_Prev_Charges_Total'] += el.charges.Curr_Year_FC_Prev_Charges;
      }
      if(el.charges && el.charges.Curr_Year_FC_Curr_Charges != null){
        val['Curr_Year_FC_Curr_Charges_Total'] += el.charges.Curr_Year_FC_Curr_Charges;
      }
      if(el.charges && el.charges.Future_Year_FC_Prev_Charges != null){
        val['Future_Year_FC_Prev_Charges_Total'] += el.charges.Future_Year_FC_Prev_Charges;
      }
      if(el.charges && el.charges.Future_Year_FC_Curr_Charges != null){
        val['Future_Year_FC_Curr_Charges_Total'] += el.charges.Future_Year_FC_Curr_Charges;
      }
      el['ask_global_id'] = val['ask_global_id'];
    })
    return val;
  }

  addApplicationIdInVolServices(arr:Array<any> = [],id){
    arr.forEach(element => {
      element['ask_global_id'] = id;
    });
    return arr;
  }

  public getForecastMasterData(){
    const url = this.apiUrl + this.configV4.getForecastMasterData;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  public getForecastServiceData(){
    const url = this.apiUrl + this.configV4.getForecastServiceData;
    if (this.cacheService.has(url)) {
      return of(this.cacheService.get(url));
    }else{
      return this.http.get(url).pipe(
        map(data => {
          this.cacheService.set(url, data);
          return data;
        })
      );
    }
  }

  public getServicesList() {
    const url = this.apiUrl + this.configV4.getServicesList;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  public addService(body) {
    // delete cache url data for filter API call
    const deleteUrl = this.apiUrl + this.configV4.getForecastFilters;
    this.cacheService.delete(deleteUrl);
    
    const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };

    const url = this.apiUrl + this.configV4.addService;
    return this.http.put<any>(url, body, options);
  }
  public getMasterCardStats(){
    const url = this.apiUrl + this.configV4.getMasterCardStats;
    return this.http.get(url).pipe(
      map(data=>{
        return data
      })
    );
  }

  public getForecastCyclesData(){
    const url = this.apiUrl + this.configV4.getForecacastData;
    return this.http.get(url).pipe(
      map(data =>{
        return data;
      })
    );
  }
  public getApplicationStats(body){
    const url = this.apiUrl + this.configV4.getApplicationStats;
    return this.http.post(url,body).pipe(
      map(data=>{
        return data;
      })
    )
  }

  public addForecastCycle(body) {
    const url = this.apiUrl + this.configV4.addForecast;
    return this.http.put(url,body).pipe(
      map(data => {
        return data;
      })
    );
  }

  updateForecastMaster(body) {
    const url = this.apiUrl + this.configV4.updateForecastMaster;
    return this.http.put(url, body).pipe(
      map(data => {
        return data;
      })
    )
  }

  updateForecastServiceMapping(body) {
    const url = this.apiUrl + this.configV4.updateForecastServiceMapping;
    return this.http.put(url, body).pipe(
      map(data => {
        return data;
      })
    )
  }

  public getFieldData(body): Observable<any>{
    const url = this.apiUrl + this.configV4.getFieldData + '?initiativeID=' + body.initiativeID + '&activeFlag=' + body.activeFlag;
    return this.http.get(url,body).pipe(
      map(data=>{
        return data;
      })
    )
  }

  public enabledFields(body): Observable<any> {
    const url = this.apiUrl + this.configAttribute.enableFieldUrl;
    return this.http.put(url,body).pipe(
      map(data => {
        return data;
      })
    );
  }

  public getAllInitiativeRoles(payload) : Observable<any> {
    const url = this.apiUrl + this.config.routerpath.allInitiativeRolesURl+'/'+payload.initiativeID;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      })
    );
  }
    
  public updateColorderForInitiatives(payload,initiativeID): Observable<any> {
    const url = this.apiUrl + this.configV4.updateColumnOrder + '/reorder-column?initiativeID=' + initiativeID;
   return this.http.put(url,payload)
   .pipe(
     map(data => {
       return data;
     })
   );
  }
  public updateFieldForInitiatives(payload): Observable<any> {
    const url = this.apiUrl + this.configV4.updateField;
   return this.http.put(url,payload)
   .pipe(
     map(data => {
       return data;
     })
   );
  }

  public getAllUsedWords(payload) : Observable<any> {
    const url = this.apiUrl + this.configV4.getAllUsedWords+'/'+payload.initiativeID + '?columnId=' + payload.columnID;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  public getForecastOwnerDetails(): Observable<any> {
    const url = this.apiUrl + this.config.routerpath.fcOwnerDetails;
    const headers = new HttpHeaders({
      'Content-Type': ''
    });
    const options = {
      headers: headers
    }
    return this.http.get<any>(url, options);
}
public isValidId(id: any): boolean {
  if (id === null || id === undefined || id === '') {
    return false;
  }
  return true;
}
public getUCMGDetails(fundSegId): Observable<any> {
  if (!this.isValidId(fundSegId)) {
    throw new Error('Invalid ID');
  }
    const url = this.apiUrl + this.configV4.getUcmgDetails+fundSegId;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  public sortServiceList = (serviceLst: any[], toggleValue: string, FC_Curr_key: string, edit_toh_key: string) => {
    return serviceLst.sort((a, b) => {
      if (b[toggleValue][FC_Curr_key] === a[toggleValue][FC_Curr_key]) {
        return a.sv_desc.localeCompare(b.sv_desc);
      }
      return b[toggleValue][FC_Curr_key] - a[toggleValue][FC_Curr_key];
    });
  };

  // Get Forecast Role Management Data
  public getForecastRoleManagementData(): Observable<any> {
    const url = this.apiUrl + this.configV4.getForecastRoleManagementData;
    if (this.cacheService.has(url)) {
      return of(this.cacheService.get(url));
    }else{
      return this.http.get(url).pipe(
        map(data => {
          this.cacheService.set(url, data);
          return data;
        })
      );
    }
  }

  //Add User in Forecast Role Management
  public addInfraForecastOwnerAccess(payload): Observable<any> {
    const url = this.apiUrl + this.configV4.addInfraForecastOwnerAccess;
   return this.http.put(url,payload)
   .pipe(
     map(data => {
       return data;
     })
   );
  }

  //Update User in Forecast Role Management
  public updateInfraForecastOwnerAccess(payload): Observable<any> {
    const url = this.apiUrl + this.configV4.updateInfraForecastOwnerAccess;
   return this.http.put(url,payload)
   .pipe(
     map(data => {
       return data;
     })
   );
  }


  // Clearing cache key
  deleteCachedData(key: string) {
    const url = this.apiUrl + this.configV4[key];
    this.cacheService.delete(url);
  }

  public triggerDataBricksWorkflow(payload): Observable<any> {
    const url = this.apiUrl + this.configV4.triggerDataBricksWorkflow;
    return this.http.post(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  public capitalDemandBulkPreview(payload): Observable<any> {
    payload['userDetails']= this.userDtls;
    const url = this.largeApiUrl + this.configV4.capitalDemandBulkPreview;
    return this.http.post(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }
  public getOtLeaderData(): Observable<any> {
    const url = this.apiUrl + this.configV4.getOtLeaderData;
    return this.http.get(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  public capitalDemandBulkSubmit(payload): Observable<any> {
    payload['userDetails']= this.userDtls;
     const url = this.largeApiUrl + this.configV4.capitalDemandBulkSubmit;
    return this.http.put(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }
  public capitalDemandAddAllocation(payload): Observable<any> {
    const url = this.apiUrl + this.configV4.capitalDemandAddAllocation;
    return this.http.put(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }
  public getMarginLessDetails(body): Observable<any> {
    const url = this.apiUrl + this.configV4.getMarginLessDetails;
    return this.http.post(url, body).pipe(
      map(data => {
        return data;
      })
    );
  }

  public capitalDemandUpdateAllocation(payload): Observable<any> {
    const url = this.apiUrl + this.configV4.capitalDemandUpdateAllocation;
    return this.http.put(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  public capitalDemandDeleteAllocation(body): Observable<any> {
    const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
            body
        }
    const url = this.apiUrl + this.configV4.capitalDemandDeleteAllocation;
    return this.http.delete<any>(url, options);
  }

  public proposalStatusUpdate(payload: any): Observable<any> {
    const url = this.apiUrl + this.configV4.proposalStatusUpdate;
    return this.http.put(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  public reqJustification2(payload: any, reqid): Observable<any> {
    const url = this.apiUrl + this.configV4.reqJustification2 + `${reqid}`;
    return this.http.put(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  public proposalUpdatePOST(payload: any): Observable<any> {
    const url = this.apiUrl + this.configV4.proposalUpdatePOST;
    return this.http.put(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  public ucmgDisableCheck(payload: any): Observable<any> {
    const url = this.apiUrl + this.configV4.ucmgDisableCheck;
    return this.http.put(url, payload).pipe(
        map(data => {
          return data;
        })
      );
    }

    public capitalDemandUCMGBulkPreview(payload): Observable<any> {
      const url = this.largeApiUrl + this.configV4.capitalDemandUCMGBulkPreview;
      return this.http.post(url, payload).pipe(
        map(data => {
          return data;
        })
      );
    }

    public capitalDemandUCMGBulkSubmit(payload): Observable<any> {
      payload['userDetails']= this.userDtls;
      const url = this.largeApiUrl + this.configV4.capitalDemandUCMGBulkSubmit;
      return this.http.put(url, payload).pipe(
        map(data => {
          return data;
        })
      );
    }

    /**
     * 
     * @param payload 
     * @returns 
     */
    public getNewApplication(payload): Observable<any> {
      const url = this.apiUrl + this.configV4.getNewApplication;
      return this.http.post(url, payload).pipe(
        map(data => {
          return data;
        })
      );
    }


    // Get Forecast Role Management Data
  public getForecastMultiMatrixData(): Observable<any> {
    const url = this.apiUrl + this.configV4.getForecastMultiMatrixData;
    if (this.cacheService.has(url)) {
      return of(this.cacheService.get(url));
    }else{
      return this.http.get(url).pipe(
        map(data => {
          this.cacheService.set(url, data);
          return data;
        })
      );
    }
  }

  public saveForecastMultiMatrix(payload: any): Observable<any> {
    const url = this.apiUrl + this.configV4.addForecastMultiMatrixData;
    return this.http.put(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  } 

  public updateForecastMultiMatrix(payload: any, id): Observable<any> {
    const url = this.apiUrl + this.configV4.updateForecastMultiMatrixData +`/${id}`;
    return this.http.put(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  } 

  public deleteForecastMultiMatrixData(payload): Observable<any> {
    const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
            body: payload
        }
    const url = this.apiUrl + this.configV4.deleteForecastMultiMatrixData;
    return this.http.delete<any>(url, options);
  }

  public getUCMGLeadersList(payload): Observable<any> {
    const url = this.apiUrl + this.configV4.getUCMGLeadersList;
    return this.http.post(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }
  
  setAdminDashboardUpdated(value: boolean) {
    this.cacheService.set('isAdminDashboardUpdated', value);
  }

  getIsAdminDashboardUpdated() : boolean {
    return this.cacheService.get('isAdminDashboardUpdated') || false;
  }

  public updateDecomLobOwnerTargetTargetYear(segmentId: string, payload: any): Observable<any> {
    const url = this.apiUrl + this.configV4.updateDecomLobSegment;
    return this.http.put<any>(url, payload, { params: { segmentId } }).pipe(
      map(data => {
        return data;
      })
    );
  }
  
  public addNewDecomLobSegment(payload): Observable<any> {
    const url = this.apiUrl + this.configV4.addNewDecomLobSegment;
    return this.http.put(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  public updateDecomLobSegment(payload, lobId) : Observable<any>  {
    const url = this.apiUrl + this.configV4.updateSegForLob;
    return this.http.put(url, payload, { params: { lobId } }).pipe(
      map(data => {
        return data;
      })
    );
  }

  public callADFPipelineForExcelExport(payload): Observable<any> {
    const url = this.largeApiUrl + this.configV4.callADFPipelineForExcelExport;
    return this.http.post(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  public getHierarchyLeaderComments(payload): Observable<any> {
    const url = this.apiUrl + this.configV4.getHierarchyLeaderComments;
    return this.http.post(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  public addHierarchyLeaderComments(payload): Observable<any> {
    const url = this.apiUrl + this.configV4.addHierarchyLeaderComments;
    return this.http.post(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  setForecastDropdownData(data: any) {
    this.cacheService.set('forecastDropdownData', data);
  }

  getForecastDropdownData() {
    return this.cacheService.get('forecastDropdownData');
  }

}


